import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onlinecabbookingpune() {



const cardData = {
  keyword: " Online Cab Booking Pune  ",

"headingDescription": "SRS Cab Service offers Online Cab Booking Pune, providing a fast, convenient, and reliable way to book cabs for local travel, airport transfers, and outstation trips. With an easy online booking system, well-maintained vehicles, and professional drivers, we ensure a smooth and hassle-free travel experience across Pune. Whether for business travel, daily commuting, or leisure trips, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a seamless journey.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort and one of Pune’s most famous landmarks. Travelers using Online Cab Booking Pune from SRS Cab Service often visit to explore its architecture and historical importance."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a key historical monument associated with India’s freedom movement. Visitors using SRS Cab Service often explore its beautiful gardens and museum exhibits."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a well-known hill fort offering scenic views and trekking opportunities. Travelers using SRS Cab Service often include this destination for adventure and sightseeing."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is a revered religious site in Pune. Visitors using SRS Cab Service often visit to seek blessings and experience spiritual peace."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva. Travelers using SRS Cab Service often enjoy its calm atmosphere and historical charm."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum showcases a rich collection of Indian artifacts. Visitors using SRS Cab Service often explore Pune’s cultural heritage here."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple offers panoramic views of Pune along with historic temples. Travelers using SRS Cab Service often visit for sightseeing and relaxation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a scenic getaway near Pune known for its peaceful surroundings. Visitors using SRS Cab Service often include this spot for leisure and photography."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden is a beautifully maintained Japanese-style garden. Travelers using SRS Cab Service often enjoy its greenery and serene ambiance."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic palace associated with Chhatrapati Shivaji Maharaj. Visitors using SRS Cab Service often explore this landmark to understand Pune’s heritage."
  }
],



services: [
{
name: "Online Cab Booking Pune",
description: "Online cab booking Pune provides fast and convenient booking options for daily and outstation travel. Customers can book cabs instantly through digital platforms. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online in Pune."
},
{
name: "Taxi Booking Pune",
description: "Taxi booking Pune offers quick and reliable reservation for city and intercity travel. Customers can book taxis online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily in Pune."
},
{
name: "Cab Booking Website in Pune",
description: "Cab booking website in Pune provides online platforms for easy cab reservations. Customers can book cabs anytime from anywhere. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily through websites."
},
{
name: "Online Taxi Booking Pune",
description: "Online taxi booking Pune offers simple and instant booking for daily and outstation travel. Customers can reserve taxis online quickly. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily online."
},
{
name: "Mumbai Airport to Pune Taxi Online Booking",
description: "Mumbai airport to Pune taxi online booking offers convenient intercity travel solutions. Customers can book taxis for airport transfers. Professional drivers ensure safe highway journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily online."
},
{
name: "Online Cab Booking Mumbai to Pune",
description: "Online cab booking Mumbai to Pune provides quick reservation options for intercity travel. Customers can book cabs online for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Online Cab Service in Pune",
description: "Online cab service in Pune offers reliable transportation booking for local and outstation travel. Customers can book cabs through online platforms. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with online cab services."
},
{
name: "Online Cabs in Pune",
description: "Online cabs in Pune provide convenient booking options for daily travel. Customers can book cabs instantly for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with online cab services."
},
{
name: "Online Car Booking in Pune",
description: "Online car booking in Pune offers easy vehicle reservation for personal and business travel. Customers can book cars instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with car booking services."
},
{
name: "Online Taxi Pune",
description: "Online taxi Pune provides fast booking options for city and outstation travel. Customers can reserve taxis instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with online taxi services."
},
{
name: "Taxi Booking in Pune",
description: "Taxi booking in Pune offers convenient travel solutions for daily and long-distance trips. Customers can book taxis easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi booking services."
},
{
name: "Pune to Shirdi Cab Booking Online",
description: "Pune to Shirdi cab booking online offers easy reservation for temple travel. Customers can book cabs instantly for pilgrimage trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily to Shirdi with online cab services."
},
{
name: "Online Cab Service Pune",
description: "Online cab service Pune provides reliable booking options for city and outstation travel. Customers can book cabs quickly through apps or websites. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with online cab services."
},
{
name: "Online Cab Service Pimpri Chinchwad",
description: "Online cab service Pimpri Chinchwad offers convenient booking for local and intercity travel. Customers can book cabs instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Online Cab Service Viman Nagar",
description: "Online cab service Viman Nagar provides premium booking options for airport and corporate travel. Customers can book cabs online easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Online Tempo Traveller Booking in Pune",
description: "Online tempo traveller booking in Pune offers group travel solutions for tours and events. Customers can book spacious vehicles easily online. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Best Online Cab Booking Pune",
description: "Best online cab booking Pune offers top-rated booking services for customers. Travelers can enjoy fast and reliable reservations. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily with best services."
},
{
name: "Cheap Online Cab Booking Pune",
description: "Cheap online cab booking Pune provides budget-friendly booking options for travel. Customers can book cabs at affordable prices. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Book your cab easily with cheap services."
},
{
name: "Affordable Online Cab Booking Pune",
description: "Affordable online cab booking Pune offers cost-effective booking solutions for daily travel. Customers can book cabs at competitive prices. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Book your cab easily online."
},
{
name: "Instant Online Cab Booking Pune",
description: "Instant online cab booking Pune provides quick and hassle-free booking options. Customers can book cabs instantly for urgent travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab instantly online."
},
{
name: "Fast Online Cab Booking Pune",
description: "Fast online cab booking Pune offers quick reservation for daily and outstation travel. Customers can book cabs in seconds online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Secure Online Cab Booking Pune",
description: "Secure online cab booking Pune provides safe and trusted booking platforms for customers. Users can book cabs with secure payment options. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab securely online."
},
{
name: "Reliable Online Cab Booking Pune",
description: "Reliable online cab booking Pune offers dependable booking solutions for customers. Travelers can book cabs easily with trusted services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Online Cab Booking Pune Near Me",
description: "Online cab booking Pune near me offers quick nearby cab booking options. Customers can find and book cabs instantly. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily near you."
},
{
name: "Pune Airport Cab Booking Online",
description: "Pune airport cab booking online provides convenient booking for airport transfers. Customers can book cabs for timely pickup and drop. Professional drivers ensure punctual journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your airport cab easily online."
},
{
name: "Outstation Cab Booking Pune Online",
description: "Outstation cab booking Pune online offers easy reservation for long-distance travel. Customers can book cabs for tours and business trips. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "One Way Cab Booking Pune Online",
description: "One way cab booking Pune online offers economical travel without return charges. Customers can book direct rides easily online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Book your cab easily online."
}
],

tableData: [
["Online Cab Booking Pune","Taxi Booking Pune"],
["Cab Booking Website in Pune","Online Taxi Booking Pune"],
["Mumbai Airport to Pune Taxi Online Booking","Online Cab Booking Mumbai to Pune"],
["Online Cab Service in Pune","Online Cabs in Pune"],
["Online Car Booking in Pune","Online Taxi Pune"],
["Taxi Booking in Pune","Pune to Shirdi Cab Booking Online"],
["Online Cab Service Pune","Online Cab Service Pimpri Chinchwad"],
["Online Cab Service Viman Nagar","Online Tempo Traveller Booking in Pune"],
["Best Online Cab Booking Pune","Cheap Online Cab Booking Pune"],
["Affordable Online Cab Booking Pune","Instant Online Cab Booking Pune"],
["Fast Online Cab Booking Pune","Secure Online Cab Booking Pune"],
["Reliable Online Cab Booking Pune","Online Cab Booking Pune Near Me"],
["Pune Airport Cab Booking Online","Outstation Cab Booking Pune Online"],
["One Way Cab Booking Pune Online","Online Cab Booking Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Easy Online Cab Booking in Pune",
    WhyChoosedescription: "SRS Cab Service offers quick and hassle-free online cab booking in Pune through mobile and web, allowing you to book your ride instantly anytime."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "We provide budget-friendly online cab booking in Pune with clear pricing. Customers receive upfront fare details with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Online Booking Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7, enabling customers to book cabs online anytime for local travel, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Options",
    WhyChoosedescription: "Choose from hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for every travel need."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles ensuring a smooth and comfortable ride across Pune."
  },
  {
    WhyChooseheading: "Instant Confirmation & Quick Pickup",
    WhyChoosedescription: "Get instant booking confirmation and fast pickup from your location anywhere in Pune including Hinjewadi, Kharadi, Viman Nagar, and Hadapsar."
  },
  {
    WhyChooseheading: "Professional & Verified Drivers",
    WhyChoosedescription: "Our trained drivers ensure safe driving, polite behavior, and reliable service for every online cab booking."
  },
  {
    WhyChooseheading: "Trusted Online Cab Service in Pune",
    WhyChoosedescription: "SRS Cab Service is trusted for online cab booking in Pune due to reliable service, affordable pricing, and excellent customer satisfaction."
  }
]
}

const faqData = [
  { question: "How can I book cab online in Pune?", answer: "You can book cab online in Pune through SRS Cab Service website or by contacting via phone." },
  { question: "Is online cab booking available 24 hours?", answer: "Yes, our online cab booking service operates 24/7." },
  { question: "Which vehicles are available for online booking?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Do you provide airport cab booking online?", answer: "Yes, we provide Pune Airport pickup and drop services through online booking." },
  { question: "Can I book outstation cab online?", answer: "Yes, we provide online booking for both local and outstation cab services." },
  { question: "Is one-way cab booking available online?", answer: "Yes, we provide one-way and round-trip cab booking options." },
  { question: "Do I get instant confirmation?", answer: "Yes, customers receive instant confirmation for online cab bookings." },
  { question: "Are drivers verified?", answer: "Yes, all drivers are trained, experienced, and verified." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Deshmukh",
    feedback:
      "Booked cab online in Pune. Very easy process and quick pickup.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Riya Kulkarni",
    feedback:
      "Best online cab booking service in Pune. Smooth ride and affordable pricing.",
    rating: 5
  }
];



























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Online Cab Booking Pune - SRS Cab & Tours",
  "description": "Book cabs online in Pune for local rides, airport transfers, one-way trips, and outstation travel. Affordable and reliable online cab service in Pune.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/online-cab-booking-pune",
  "areaServed": [
    "Pune, Maharashtra",
    "Mumbai",
    "Shirdi",
    "Pimpri Chinchwad",
    "Viman Nagar",
    "Goa",
    "Aurangabad"
  ],
  "openingHours": "Mo-Su 06:00-22:00",
  "priceRange": "₹₹",
  "serviceType": [
    "Online Cab Booking Pune",
    "Taxi Booking Pune",
    "Pune Airport Taxi Online",
    "Online Tempo Traveller Booking Pune",
    "One Way Cab Pune",
    "Outstation Cab Service Pune"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1270"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Online Cab Booking Pune | SRS Cab & Tours</title>
  <meta 
    name="description" 
    content="Book cabs online in Pune for airport transfers, outstation trips, one-way rides, and local travel. Affordable, reliable, and best online cab service in Pune." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/58.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onlinecabbookingpune;